export class AppConstants {
  public static get LOCKED_ASPECT(): string {
    return 'cm:lockable';
  }
  public static get CHECKEDOUT_ASPECT(): string {
    return 'cm:workingcopy';
  }
  public static get WORKING_COPY_OWNER(): string {
    return 'cm:workingCopyOwner';
  }
  public static get WORKING_COPY_LINK(): string {
    return 'cm:workingcopylink';
  }
  public static get LOCK_OWNER(): string {
    return 'cm:lockOwner';
  }
}
